import React from 'react';
import ReactDOM from 'react-dom';
// import "bootstrap/dist/css/bootstrap.min.css";
import './css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga'; // react google analytics

// uncomment these and put in your analytics credentials to use google analytics
//ReactGA.initialize('UA-XXXXXX-Y');
// report a page view
//ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
